import { apiClient } from "@/lib/api/client";
import { getDataOrThrowApiError } from "@/lib/api/error";

export async function getOperationPackageInstance(params: {
  instanceId: string;
}) {
  const { instanceId } = params;

  const res = await apiClient.GET(
    "/v2/it-operation-core/operation-instances/{id}",
    { params: { path: { id: instanceId } } },
  );

  return getDataOrThrowApiError(res);
}

export async function abortInstance(params: {
  instanceId: string;
}) {
  const { instanceId } = params;

  const res = await apiClient.PATCH(
    "/v2/it-operation-core/operation-instances/{id}/abort",
    { params: { path: { id: instanceId } } },
  );

  return getDataOrThrowApiError(res);
}
